import {
  ISLAND_KEYS,
  getIslandCapabilities,
  getIslandConfig,
  getIslandUrl,
} from 'alakai-aloha-shared';

const ISLAND_DETAILS = {
  kauai: {
    status: 'Full edition',
    description: 'The complete Kauai edition with deep guides, planning tools, photo planning, sample itineraries, and curated local profiles.',
    note: 'Live with the full island toolkit.',
    menuDescription: 'Live with the full planning experience.',
    accent:
      'radial-gradient(circle at top left, rgba(34, 197, 169, 0.34), transparent 55%), linear-gradient(140deg, rgba(8, 60, 72, 0.32), rgba(0, 0, 0, 0))',
    highlights: ['Guides', 'Trip planner', 'Photo planner'],
  },
  oahu: {
    status: 'Live edition',
    description: 'Designed around neighborhoods, surf, food, and the island\'s urban-energy mix.',
    note: 'Live with the core island guide, trip planner, profiles, and planning tools. Photo planner and sample itineraries are still to come.',
    menuDescription: 'Live with planner, guides, profiles, and core tools.',
    accent:
      'radial-gradient(circle at top left, rgba(96, 165, 250, 0.3), transparent 55%), linear-gradient(140deg, rgba(10, 36, 76, 0.3), rgba(0, 0, 0, 0))',
    highlights: ['Neighborhoods', 'Surf culture', 'Food scene'],
  },
  maui: {
    status: 'Live edition',
    description: 'Built for beach days, road trips, Upcountry, and slower resort-to-adventure pacing.',
    note: 'Live with the core island guide, trip planner, profiles, and planning tools. Photo planner and sample itineraries are still to come.',
    menuDescription: 'Live with planner, guides, profiles, and core tools.',
    accent:
      'radial-gradient(circle at top left, rgba(251, 146, 60, 0.3), transparent 55%), linear-gradient(140deg, rgba(92, 33, 10, 0.34), rgba(0, 0, 0, 0))',
    highlights: ['Road to Hana', 'Beach time', 'Upcountry'],
  },
  big_island: {
    status: 'Live edition',
    description: 'Built for scale: Kona, Hilo, volcanoes, dark skies, and long transfer days.',
    note: 'Live with the core island guide, trip planner, profiles, and planning tools. Photo planner and sample itineraries are still to come.',
    menuDescription: 'Live with planner, guides, profiles, and core tools.',
    accent:
      'radial-gradient(circle at top left, rgba(244, 114, 182, 0.22), transparent 55%), linear-gradient(140deg, rgba(66, 24, 24, 0.36), rgba(0, 0, 0, 0))',
    highlights: ['Volcanoes', 'Two coasts', 'Big distances'],
  },
};

export const APEX_FUTURE_PRODUCT_LINKS = [
  {
    id: 'multi-island-planner',
    label: 'Multi-Island Planner',
    href: '/coming-soon?feature=multi-island-planner',
    status: 'Coming soon',
    description: 'A shared itinerary builder for trips spanning two or more islands.',
    detail: 'Interview once, then shape transfer days, flight cadence, and trip pacing from one plan.',
    highlights: ['Cross-island pacing', 'Transfer-day logic', 'Shared itinerary layer'],
    ctaLabel: 'Preview this roadmap',
  },
  {
    id: 'choose-your-island',
    label: 'Choose Your Island',
    href: '/quiz/choose-island',
    status: 'Live',
    description: 'A decision tool for travelers who know Hawaii, but not where to begin.',
    detail: 'Answer a few questions and get routed to the island edition that best fits your style, pace, and priorities.',
    highlights: ['Trip-fit guidance', 'Fast decision support', 'Best-first routing'],
    ctaLabel: 'Take the quiz',
  },
];

export function getApexIslandEntries() {
  return ISLAND_KEYS.map((islandKey) => {
    const island = getIslandConfig(islandKey);
    const capabilities = getIslandCapabilities(islandKey);
    const detail = ISLAND_DETAILS[islandKey];

    return {
      key: islandKey,
      title: island.title,
      shortTitle: island.shortTitle,
      domain: `${island.subdomain}.alakaialoha.com`,
      href: getIslandUrl(islandKey, '/'),
      live: Boolean(capabilities.tripPlanner),
      ctaLabel: capabilities.tripPlanner ? `Explore ${island.shortTitle}` : `Visit ${island.shortTitle} subdomain`,
      ...detail,
    };
  });
}
